var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSketchFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 16H13C14.6569 16 16 14.6574 16 13.0005V6L10 0H3.00007C1.34322 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16Z",
    fill: "url(#paint0_linear_307_255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15.75H3C1.48122 15.75 0.25 14.5188 0.25 13V3C0.25 1.48123 1.48128 0.25 3.00007 0.25H9.89645L15.75 6.10355V13.0005C15.75 14.5192 14.5188 15.75 13 15.75Z",
    stroke: "black",
    strokeOpacity: 0.06,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_307_255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4V0L16 6H12C10.8954 6 10 5.10457 10 4Z",
    fill: "url(#paint1_linear_307_255)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.90162 11.2213C7.29158 11.0714 7.79674 11.0283 8.25576 11.0178H8.27862C8.40502 11.0178 8.51977 10.9215 8.53097 10.7925C8.54262 10.664 8.43908 10.5459 8.30147 10.5246C7.76225 10.4818 7.25709 10.4818 6.6833 10.6317C6.5457 10.6745 6.39643 10.728 6.25883 10.8248C6.12122 10.9211 5.98361 11.05 5.90292 11.2322C5.86841 11.318 5.84555 11.4143 5.8339 11.511C5.8339 11.6182 5.84555 11.7363 5.89127 11.8326C5.99436 12.047 6.16648 12.1651 6.30455 12.24C6.59142 12.4008 6.85543 12.4544 7.10778 12.5293C7.36013 12.5938 7.60129 12.6474 7.81913 12.701C7.92222 12.7333 8.02576 12.7655 8.09434 12.7973C8.07148 12.8082 8.04862 12.8187 8.0141 12.8296C7.63534 12.969 7.13064 13.0439 6.65996 13.1084C6.17811 13.1729 5.68461 13.2265 5.19108 13.2692C4.69757 13.3119 4.20406 13.355 3.69936 13.3873L2.20763 13.5054C2.09289 13.5163 2.001 13.5912 2.001 13.6984C1.98934 13.8165 2.08123 13.9237 2.20763 13.9341C3.21751 14.0091 4.22743 14.0091 5.23675 13.9877C5.74145 13.9664 6.24662 13.9341 6.76301 13.8805C7.27937 13.8161 7.78408 13.7625 8.33494 13.559C8.47254 13.5054 8.62181 13.4409 8.79393 13.2801C8.83965 13.2374 8.88582 13.1838 8.92033 13.1193C8.94319 13.0871 8.95485 13.0444 8.96605 13.0012L8.98892 12.9154C9.01178 12.8082 9.00057 12.6583 8.94319 12.5293C8.81679 12.2723 8.62181 12.1651 8.47255 12.1006C8.32328 12.0361 8.18568 11.9934 8.04807 11.9507C7.78406 11.8862 7.53171 11.8326 7.30221 11.7899C7.07271 11.7472 6.84322 11.6936 6.68276 11.6182C6.60252 11.586 6.56801 11.5433 6.56801 11.5433C6.55635 11.5433 6.56801 11.5433 6.55635 11.5219C6.55635 11.5006 6.55635 11.4792 6.56801 11.4575C6.5689 11.4034 6.70664 11.2962 6.90162 11.2213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02843 13.2652C2.04959 13.2872 2.07836 13.2997 2.10874 13.3C2.12068 13.3 2.13235 13.2978 2.14348 13.2935L2.31498 13.2283L3.84326 12.6155C3.85682 12.6109 3.86876 12.6028 3.87799 12.5916L8.05686 8.40647C8.21316 8.253 8.30081 8.04304 8.3 7.82411C8.29918 7.51963 8.13175 7.24013 7.86366 7.09616C7.62052 6.96795 7.32963 6.96795 7.08646 7.09616C7.07099 7.10322 7.05661 7.11191 7.04304 7.12223C7.03219 7.12875 7.00614 7.14396 6.98226 7.16134C6.95051 7.18552 6.92066 7.21241 6.89326 7.24174L2.71216 11.4247C2.70104 11.4339 2.6929 11.4459 2.68828 11.4594L2.00881 13.15C1.99199 13.1888 1.99966 13.2343 2.02843 13.2652Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_307_255",
    x: 8,
    y: -1,
    width: 10,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_307_255"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_307_255",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_307_255",
    x1: 1,
    y1: 1,
    x2: 16,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25F5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117896,
    stopColor: "#26F3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213837,
    stopColor: "#2AEEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2912,
    stopColor: "#30E6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353363,
    stopColor: "#38DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403704,
    stopColor: "#41CFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4456,
    stopColor: "#4CC1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48243,
    stopColor: "#58B1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51757,
    stopColor: "#64A0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5544,
    stopColor: "#718EEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596296,
    stopColor: "#7F7BF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646637,
    stopColor: "#8D69F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7088,
    stopColor: "#9A57F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786163,
    stopColor: "#A745F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882104,
    stopColor: "#B434F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF25F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_307_255",
    x1: 13,
    y1: 3,
    x2: 10,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.514828,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketchFile);
export default __webpack_public_path__ + "static/media/sketch-file.183c3aa9c83787c4951441b66c49277d.svg";
export { ForwardRef as ReactComponent };